module.exports = __webpack_public_path__ + "img/组 1@2x.c57e32aa.png";